export type ColorSchema = 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error';

declare module '@mui/material/styles/createPalette' {
  interface Theme {
    button: {
      primary: {
        lighter: string,
        light: string,
        main: string,
        dark: string,
        darker: string
      },
      secondary: {
        lighter: string,
        light: string,
        main: string,
        dark: string
      }
    }
  }
  interface TypeBackground {
    neutral: string;
  }
  interface SimplePaletteColorOptions {
    lighter: string;
    darker: string;
  }
  interface PaletteColor {
    lighter: string;
    darker: string;
  }
}

// SETUP COLORS
export const GREY = {
  0: '#FFFFFF',
  50: "#F0F0F0",
  100: "#F5F5F5",
  200: '#E4E5E9', // light grey
  300: '#EDEDED', // main grey
  400: '#909299', // placeholder
  500: '#808080', // light grey text color
  600: '#707580', // middle grey - description
  800: '#282828', // dark grey / black
  900: '#202329' // dark grey
}

export const PRIMARY = {
  lighter: '#ffdec7', //  light orange color
  light: '#FFD5B6',
  main: '#FF6B00', // main orange color
  dark: "#F16500",
  darker: '#f36600', //  dark orange color
}

export const SECONDARY = {
  lighter: '#ffdec7',
  main: '#F5F5F5',
  darker: '#f36600',
}

export const palette = {
  common: { black: '#000', white: '#fff' },

  primary: {
    light: '#FFD5B6', // light orange color
    lighter: '#ffdec7', //  light orange color
    main: '#FF6B00', // main orange color
    darker: '#f36600', //  dark orange color
    dark: "#F16500",
  },

  secondary: {
    lighter: '#FFFFFF', //  white color
    main: '#F5F5F5', // light text
    darker: '#202329', //  dark-gray color
  },

  grey: GREY,

  text: {
    primary: GREY[800], // primary black text color
    secondary: GREY[600], // secondary text color
    light: GREY[500], // light text
    accent: PRIMARY.main
  },

  background: {
    paper: '#fff',
    default: '#f7f8fa',  // main bg color
  },

  button: {
    primary: {
      lighter: PRIMARY.lighter,
      light: PRIMARY.light,
      main: PRIMARY.main,
      dark: PRIMARY.dark,
      darker: PRIMARY.darker
    },
    secondary: {
      lighter: GREY[50],
      light: GREY[100],
      main: GREY[200],
      dark: GREY[400]
    }
  },

  select: SECONDARY,

  action: {
    hover: PRIMARY.darker,
    focus: PRIMARY.darker,
    disabledOpacity: 0.8,
  },
}